/* eslint-disable @typescript-eslint/no-unused-vars */
import React from "react";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

const InfoTab: React.FC<{
  setSwalProps: any;
  userProfile: any;
  isFetching: boolean;
}> = ({ setSwalProps, userProfile, isFetching }) => {
  const formatDate = (timestamp: string, timeZone: string) => {
    return dayjs.utc(timestamp).tz(timeZone).format("DD MMM YY - hh:mm A");
  };

  return (
    <>
      <div className="p-7">
        {userProfile !== null ? (
          <>
            <div className="text-sm text-navy-700 dark:text-white">
              <div className="grid grid-cols-1 gap-y-4 md:grid-cols-2 md:gap-x-6">
                {/* Username */}
                <div className="flex">
                  <label className="w-36 shrink-0 text-sm font-normal">
                    Username:
                  </label>
                  <span className="font-semibold">{userProfile.username}</span>
                </div>

                {/* Latest Login */}
                <div className="flex">
                  <label className="w-36 shrink-0 text-sm font-normal">
                    Latest Login:
                  </label>
                  <span className="font-semibold">
                    {userProfile.latest_login
                      ? formatDate(
                          userProfile.latest_login,
                          userProfile.time_zone
                        )
                      : "-"}
                  </span>
                </div>

                {/* Email */}
                <div className="flex">
                  <label className="w-36 shrink-0 text-sm font-normal">
                    Email:
                  </label>
                  <span className="font-semibold">{userProfile.email}</span>
                </div>
              </div>
            </div>
          </>
        ) : (
          <>
            <div
              className="mb-3 mt-3 h-5 animate-pulse rounded-md bg-gray-200"
              style={{ animationDuration: "0.6s" }}
            ></div>
            <div
              className="mb-3 h-5 animate-pulse rounded-md bg-gray-200"
              style={{ animationDuration: "0.6s" }}
            ></div>
            <div
              className="mb-3 h-5 animate-pulse rounded-md bg-gray-200"
              style={{ animationDuration: "0.6s" }}
            ></div>
          </>
        )}
      </div>
    </>
  );
};

export default InfoTab;
